export default {
  GET_CREDENTIALS (state, data) {
    state.credentials = data.data
  },
  GET_ALL_CREDENTIALS (state, data) {
    state.all_credentials = data.data
  },
  GET_CREDENTIAL (state, data) {
    state.credential = data.data
  },
  GET_DELETED_CREDENTIALS (state, data) {
    state.deleted_credentials = data.data
  }
}
